import * as z from "zod";

export const electedRepresentativeTypeSchema = z.enum([
  "boardMember",
  "alternateBoardMember",
  "representative",
  "other",
]);

export type ElectedRepresentativeType = z.infer<
  typeof electedRepresentativeTypeSchema
>;
